module.exports = __webpack_public_path__ + "static/media/organizer-crown.f4895a17.svg";